import { Button, styled } from '@mui/material';
import { useEffect, useState } from 'react';

import { useThrottledCallback } from '@widget/toolbox/hooks';

const StyledButton = styled(Button)`
  position: fixed;
  z-index: 9999; // Same as the overlay CTA, less then drawer
  height: 48px;
  width: 48px;
  min-width: 48px;
  padding: 12px;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.35);
  border-radius: 2px;
`;

export function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [bottomOffset, setBottomOffset] = useState('0px');

  const handleScroll = useThrottledCallback(() => {
    const scrollPosition = window.scrollY;
    const viewportHeight = window.innerHeight;
    setIsVisible(scrollPosition > 3 * viewportHeight);
    setBottomOffset(document.body.style.paddingBottom || '0px');
  }, 100);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <StyledButton
      sx={{
        right: {
          xs: '16px',
          lg: '48px',
        },
        bottom: {
          xs: `calc(16px + ${bottomOffset} + env(safe-area-inset-bottom))`,
          lg: `calc(48px + ${bottomOffset} + env(safe-area-inset-bottom))`,
        },
        display: {
          xs: isVisible ? 'block' : 'none',
        },
      }}
      variant="contained"
      onClick={() => scrollToTop()}
    >
      <svg width="24" height="24" style={{ gap: '8px' }} viewBox="0 0 24 24" fill="none">
        <path d="M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z" fill="white" />
      </svg>
    </StyledButton>
  );
}
